<template>
  <div class="tracks-manager"  :class="{'is-disabled': !tags || tags.length === 0}">
    <div class="tracks-manager__tracks-group">
      <track-zoom @zoomUpdated="onZoomUpdated" />
      <div class="tracks-manager__tracks" :style="isWideScreen ? 'overflow-y:scroll' : ''">
        <div v-if="!tags || tags.length === 0" class="track is-placeholder _flxrcc">
          <span>add an interaction by dragging from the list</span> 
        </div>
        <draggable v-model="tags" :options="{group:'tracks', dragClass: 'sortable-drag'}" @start="drag=true" @end="drag=false" >
          <tag-track class="tracks-manager__track" v-for="tag in tags" :key="tag.id" :tag="tag" :zoom="zoom" v-on:saveScene="onSaveScene" :keyFramesTimes="keyFramesTimes"/>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import TagTrack from './tagTrack'
import TrackZoom from './trackZoom'
import draggable from 'vuedraggable'
// import { getTextFromMultiLang } from './../../utils/multiLang.js'

import { saveScene } from '../../mixins/saveScene.js'

export default {
  name: 'tracks-manager',

  components: {
    'tag-track': TagTrack,
    'track-zoom': TrackZoom,
    'draggable': draggable
  },

  mixins: [saveScene],

  props: {
    time: {
      type: Number,
      default: 0
    },
    isWideScreen: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      showTracks: true,
      zoom: {
        ratio: 1,
        center: 0,
        left: 0
      },
      trackCopy: null
    }
  },

  computed: {
    ...mapState(['video']),
    ...mapGetters(['videoDuration', 'languages', 'allWaypoints']),

    timePosition: function () {
      return {
        left: `${this.videoDuration ? this.time * 100 / this.videoDuration : 0}%`
      }
    },

    keyFramesTimes: function () {
      const allWaypoints = this.allWaypoints
      const keyFramesTimes = allWaypoints.reduce((acc,wp) => {
        return [...acc, wp.time]
      }, [])

      return [...new Set(keyFramesTimes)].sort((a,b) => a - b)
    },

    tags: {
      get: function () {
        // ToDo: Check filter function
        // const langs = this.langagues || ['de']
        // let filter = (this.textFilter || '').toLowerCase()
        // return this.video.tags.filter((tag, i, arr) => {
        //   if (tag.meta.name && tag.meta.name !== '') {
        //     return tag.meta.name.indexOf(filter) >= 0
        //   } else {
        //     return getTextFromMultiLang(tag.meta.title, langs[0]).toLowerCase().indexOf(filter) >= 0
        //   }
        // });
        return this.video.tags
      },

      set: function (value) {
        this.$store.commit('updateTags', value)
      }
    }
  },

  created() {
    document.addEventListener('mousedown', this.onClick)
  },

  beforeDestroy() {
    document.removeEventListener('mousedown', this.onClick)
  },

  methods: {
    ...mapActions(['createTag']),
    ...mapMutations(['resetSelection', 'updateTags']),

    onClick: function (event) {
      event.stopPropagation();
      let tracksGroup = event.target.closest('.tracks-manager__tracks-group')
      let editWrapper = event.target.closest('.editor__edit-wrapper')
      // let propertiesBar = event.target.closest('.properties-bar')

      // let hasScrollbar = false
      // Add safeZone when clicking on the right to prevent closing tag content
      const clickedOnSafeZone = event.clientX + 25 >= window.innerWidth

      // this is a hack to prevent code mirror markdown editor to trigger events on the document 
      // because of the given z-index the ancestor is not in the dom tree anyomre as of trackGroup and editWrapper
      // abort early if the document.body click event has a target of a code mirror markdown editor element
      let cls = event.target.className || ""
      if (cls.indexOf("CodeMirror") >= 0 || cls.indexOf("cm-") >= 0) {
        return
      }

      if (!(tracksGroup || editWrapper) && !clickedOnSafeZone) {
        // this.deselectAllTracks();
      }
    },

    onZoomUpdated: function (value) {
      this.zoom = value
    },

    onSaveScene() {
      // see mixin
      this.saveScene()
    },

    addTag: function () {
      this.createTag()
      this.showTracks = true
    },

    deselectAllTracks: function () {
        this.resetSelection()
    }
  }
}
</script>
